import "./UserRequest.scss";

import { Envelope } from "../../assets";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../../utils/dayjs";

const UserRequest = () => {
  const { employeeRequests } = useSelector((state) => state.employeeRequests);
  const { isDarkMode } = useSelector((state) => state.usersList);

  //Percakton ngjyren ne varssi te statusit te kerkeses
  const getColor = (reqStatus) => {
    switch (reqStatus) {
      case "Aprovuar":
        return "#1da193";
      case "Refuzuar":
        return "#ea3943";
      case "Pending":
        return "#FCC94A";
      default:
        return "#FCC94A";
    }
  };
  const excludeWeekends = (startDate, endDate) => {
    let count = 0;
    let curDate = +startDate;
    while (curDate <= +endDate) {
      const dayOfWeek = new Date(curDate).getDay();
      const isWeekend = dayOfWeek === 6 || dayOfWeek === 0;
      if (!isWeekend) {
        count++;
      }
      curDate = curDate + 24 * 60 * 60 * 1000;
    }
    return count;
  };
  const headerLabels = [
    "Data e krijimit",
    "Statusi",
    "Data e fillimit",
    "Data e mbarimit",
    "Dite pa fundjave",
  ];

  return (
    <div className={`user-request ${isDarkMode ? "dark" : ""}`}>
      {/* {noEmpId === true ? ( */}
      <>
        {(employeeRequests || []).length <= 0 ? (
          <div className="noData">
            <Envelope />
            <p className="request-info">Nuk ka asnjë kërkesë për të shfaqur.</p>
          </div>
        ) : (
          // <div
          //   style={{
          //     position: "absolute",
          //     top: "27%",
          //     right: "20%",
          //   }}
          // >
          //   <HollowDotsSpinner color={"#1da193"} size={24} />
          // </div>
          <>
            <div className="headersLabel">
              {headerLabels?.map((el) => {
                return <div className="headerTips">{el}</div>;
              })}
            </div>
            <>
              <div className="userRequestsData">
                {(employeeRequests || []).map((el) => {
                  return (
                    <div
                      className="requests-item"
                      style={{
                        gridTemplateColumns: `repeat(${headerLabels.length}, 1fr)`,
                      }}
                    >
                      <div className="requests-item-cell">
                        {dayjsTZ(el?.createdAt).format("DD/MM/YYYY")}
                      </div>
                      <div className="requests-item-cell">
                        <div
                          style={{
                            width: "150px",
                            backgroundColor: getColor(el?.requestStatus),
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            borderRadius: 5,
                            position: "relative",
                            height: 24,
                          }}
                        >
                          {el?.requestStatus}
                        </div>
                      </div>
                      <div className="requests-item-cell">
                        {dayjsTZ(el?.requestPeriod[0]).format("DD/MM/YYYY")}
                      </div>
                      <div className="requests-item-cell">
                        {dayjsTZ(el?.requestPeriod?.slice(-1)[0]).format(
                          "DD/MM/YYYY"
                        )}
                      </div>
                      <div className="requests-item-cell">{`${excludeWeekends(
                        new Date(
                          dayjsTZ(el?.requestPeriod[0]).format("YYYY/MM/DD")
                        ),
                        new Date(
                          dayjsTZ(el?.requestPeriod?.slice(-1)[0]).format(
                            "YYYY/MM/DD"
                          )
                        )
                      )}`}</div>
                    </div>
                  );
                })}
              </div>
            </>
            {/* <div className="values">
              {values?.map(
                ({
                  createdAt,
                  status,
                  requestStartPeriod,
                  requestEndPeriod,
                  days,
                }) => {
                  return (
                    <>
                      <div className="createdAt">
                        <span>{createdAt}</span>
                        <div
                          style={{
                            backgroundColor: getColor(
                              userRequests.requestStatus
                            ),
                            width: 80,
                            display: "flex",
                            justifyContent: "center",
                            color: "#fff",
                            borderRadius: 5,
                          }}
                        >
                          <span>{status}</span>
                        </div>
                        <div
                          style={{
                            width: 80,
                            backgroundColor: "#a4a0a0",
                            color: "#fff",
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: 5,
                            position: "relative",
                            right: 20,
                          }}
                          className="requestStartPeriod"
                        >
                          <span>{requestStartPeriod}</span>
                        </div>
                        <div
                          style={{
                            width: 80,
                            backgroundColor: "#a4a0a0",
                            color: "#fff",
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: 5,
                          }}
                        >
                          <span>{requestEndPeriod}</span>
                        </div>

                        <div className="days">
                          <span>{days}</span>
                        </div>
                      </div>
                    </>
                  );
                }
              )}
            </div> */}
            {/* <div className="addLeaveBtn">
              <Button className="add-request" onClick={showModal} disabled>
                Dërgo një kërkesë për leje
              </Button>
            </div> */}
          </>
          // <div className="requests-container">
          //   {/* dfgsd */}
          //   {userRequests?.map((req) => {
          //     return (
          //       <>
          //         <div
          //           className="request-line"
          //           onClick={() => setVisibleModal(true)}
          //           key={req.requestId}
          //         >
          //           <div
          //             className="icon-container"
          //             style={{ backgroundColor: getColor(req.requestStatus) }}
          //           >
          //             {getIcon(req.requestType)}
          //           </div>
          //           <h4 className="request-date" style={{ marginLeft: 2 }}>
          //             Kerkese eshte derguar me:
          //             {dayjsTZ(req.createdAt).format("MM/DD/YYYY")}
          //           </h4>
          //           <div
          //             className="request-type"
          //             style={{ backgroundColor: getColor(req.requestStatus) }}
          //           >
          //             {req.requestStatus}
          //           </div>
          //         </div>
          //         <EmployeLeaveRequesDetail
          //           userRequests={req}
          //           setVisibleModal={setVisibleModal}
          //           open={visible}
          //         />
          //       </>
          //     );
          //   })}
          // </div>
        )}{" "}
      </>
      {/* ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: 60,
          }}
        >
          <Alert
            type="error"
            description="Ju nuk mund te shtoni pushime!"
            showIcon
          />
        </div>
      )} */}
      {/* <AddRequestModal
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
        setUserRequests={setUserRequests}
        userRequests={userRequests}
        setAllRequests={setAllRequests}
      /> */}
    </div>
  );
};
export default UserRequest;
